$(document).ready(function(){
  function freeGift(){
    jQuery.getJSON("/cart.js", function (cart) {
      var giftId = 44565214396593;
      var giftInCart = 0;

      var triggerId = 40335858729137;
      var triggerInCart = 0;

      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == giftId){
          giftInCart += cart.items[i].quantity
        }
        if (cart.items[i].id == triggerId){
          triggerInCart += cart.items[i].quantity
        }
      }

      if (giftInCart > 0){
        if (triggerInCart < 3){
          var updates = {};
          updates[giftId] = 0;

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                updates: updates
            },
            success: function(data) {
              window.location.reload();
            }
          });
        }
      }
    });
  }

  setInterval(function(){
    freeGift();
  },1000);
  
});